export const isType = (object: any, type: string) => {
    return typeof object == type;
}

export const parseJson = (object: any, defaultValue: any = undefined) => {
    try {
        return JSON.parse(object);
    }
    catch (e) {
        return defaultValue !== undefined ? defaultValue : object;
    }
}

export const toType = (value: unknown) => typeof value;

export const isFunction = <P, T>(value: unknown): value is ((arg0: P) => T) => {
    return toType(value) === 'function';
};